import { render, staticRenderFns } from "./addQuestionForm.vue?vue&type=template&id=3555dfed&"
import script from "./addQuestionForm.vue?vue&type=script&lang=js&"
export * from "./addQuestionForm.vue?vue&type=script&lang=js&"
import style0 from "./addQuestionForm.vue?vue&type=style&index=0&id=3555dfed&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports